/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useListObservabilityProjectsQuery } from '@modules/project-admin-lib/hooks/list'
import type { ResourceQueryResult } from '@modules/role-assignments-lib/types'

import type { UseQueryOptions } from 'react-query'

export const useResourcesQuery = (
  organizationId: string,
  options?: Pick<UseQueryOptions, 'enabled'>,
): ResourceQueryResult => {
  const isEnabled = options?.enabled ?? true

  const observabilityQuery = useListObservabilityProjectsQuery(
    { organization_id: organizationId },
    { enabled: isEnabled },
  )

  return {
    resourceType: 'observability',
    data: observabilityQuery.data?.items,
    isLoading: observabilityQuery.isLoading,
    error: observabilityQuery.error,
    isEnabled,
  }
}
